import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import {
  getGossips,
  getNews,
  getHotGossips,
  getLatestArticles,
  allStars,
  sortArticles,
} from '@/utils/articles';
import { formatViews } from '@/utils/format';

export default function Home() {
  const featured = getLatestArticles(5);
  const latestGossips = sortArticles(getGossips(), 'latest').slice(0, 6);
  const hotList = getHotGossips(6);
  const newsList = sortArticles(getNews(), 'latest').slice(0, 4);
  const hotStars = allStars.slice().sort((a, b) => b.heat - a.heat).slice(0, 6);
  const totalViews = getGossips().concat(getNews()).reduce((sum, a) => sum + a.views, 0);

  return (
    <div className="w-full">
      <div className="max-w-content mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="flex items-end justify-between gap-4 mb-4 md:mb-5">
          <div>
            <h1 className="text-xl md:text-2xl font-black text-foreground-950">
              91黑料 · 最新娱乐黑料爆料平台
            </h1>
            <p className="text-sm text-foreground-500 mt-1.5">
              聚焦明星内幕、绯闻爆料与影视综艺动态，一站看全娱乐圈风向
            </p>
          </div>
          <span className="hidden md:flex items-center gap-1.5 text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-timer-flash-line text-primary-500"></i> 实时更新中
          </span>
        </div>
        <HeroCarousel items={featured} />
      </div>

      <div className="max-w-content mx-auto px-4 md:px-6 pb-10 md:pb-14 space-y-10 md:space-y-14">
        <CategoryEntries />

        <section>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
            <div className="lg:col-span-2">
              <SectionHeading
                title="最新娱乐黑料"
                subtitle="更快一步，掌握娱乐圈最新爆料动态"
                icon="ri-flashlight-line"
                moreTo="/category/feiwen"
              />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
                {latestGossips.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>

            <aside className="space-y-6">
              <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
                <div className="flex items-center gap-2 pb-3 mb-1 border-b border-background-200">
                  <i className="ri-fire-line text-primary-500 text-xl"></i>
                  <h3 className="text-base font-black text-foreground-950">热门黑料榜</h3>
                </div>
                <div>
                  {hotList.map((article, i) => (
                    <ArticleCard key={article.id} article={article} variant="compact" rank={i + 1} />
                  ))}
                </div>
              </div>

              <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
                <div className="flex items-center justify-between pb-3 mb-3 border-b border-background-200">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-star-line text-accent-600 text-xl"></i>
                    <h3 className="text-base font-black text-foreground-950">热门明星</h3>
                  </div>
                  <Link to="/star" className="text-xs text-foreground-500 hover:text-primary-600">
                    全部
                  </Link>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {hotStars.map((star) => (
                    <Link
                      key={star.id}
                      to={`/star/${star.id}`}
                      className="group flex items-center gap-2.5"
                    >
                      <span className="w-10 h-10 rounded-full overflow-hidden bg-background-100 shrink-0">
                        <img
                          src={star.avatar}
                          alt={star.name}
                          title={`${star.name}-91黑料明星专题`}
                          className="w-full h-full object-cover object-top"
                        />
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                          {star.name}
                        </span>
                        <span className="block text-[11px] text-foreground-500 truncate">{star.title}</span>
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </section>

        <section>
          <SectionHeading
            title="综合娱乐资讯"
            subtitle="除黑料之外，还有更多值得关注的娱乐新闻"
            icon="ri-newspaper-line"
            moreTo="/news"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
            {newsList.map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>
        </section>

        <section className="bg-background-100 rounded-xl p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-4">
                <i className="ri-megaphone-line"></i> 关于 91黑料
              </span>
              <h2 className="text-xl md:text-2xl font-black text-foreground-950 leading-snug">
                专注娱乐黑料与娱乐资讯的聚合门户
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
                91黑料致力于为娱乐八卦爱好者提供便捷、清晰的资讯入口。我们按分类组织内容，支持关键词搜索与多维筛选，
                将明星内幕、绯闻爆料、影视综艺动态与娱乐热点集中呈现，让你用更少的时间，掌握更全的娱乐风向。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3">
                本站所有爆料与明星信息均为虚构演示内容，仅用于产品功能展示，不涉及任何真实个人隐私，也请广大网友理性吃瓜、抵制谣言。
              </p>
              <div className="flex flex-wrap items-center gap-3 mt-6">
                <Link
                  to="/about"
                  className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  了解我们
                </Link>
                <Link
                  to="/search"
                  className="px-5 py-2.5 rounded-md bg-background-50 text-foreground-800 border border-background-300 text-sm font-medium hover:border-primary-300 transition-colors whitespace-nowrap"
                >
                  搜索黑料
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
              {[
                { value: `${getGossips().length + getNews().length}+`, label: '爆料资讯' },
                { value: `${allStars.length}`, label: '明星专题' },
                { value: formatViews(totalViews), label: '累计阅读' },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-lg p-4 border border-background-200 text-center lg:text-left"
                >
                  <p className="text-xl md:text-2xl font-black text-primary-600 font-label">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}